<template>
  <div class="blog__item">
    <div class="blog__item__header">
      <span class="date">{{ post.formattedDate }}</span>

      <ul class="blog__item__tags">
        <li v-for="cat in post.categories" :key="cat.id">{{ cat.title }}</li>
      </ul>
    </div>
    <figure v-if="post.previewImage">
      <router-link :to="`/blog/${post.slug}`">
        <img :src="post.previewImage.url" alt="" />
      </router-link>
    </figure>
    <div class="blog__item__content">
      <h2>
        <router-link :to="`/blog/${post.slug}`">
          {{ post.title }}
        </router-link>
      </h2>

      <p>{{ post.previewText }}</p>
      <router-link
        :to="`/blog/${post.slug}`"
        class="blog__item__readmore"
      >
        Mehr lesen
      </router-link>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@import '../styles/_toolbox';

.blog__item {
  grid-column: span 3;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-bottom: 4rem;
  padding: 2rem;
  line-height: 1.3;
  background: #fff;
  box-shadow: 0 0 0 1px #000;

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  .date {
    font-size: 1.5em;
    font-weight: 300;
  }
  p {
    font-weight: 300;
  }
  &__tags {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;

    li {
      background-color: var(--c-bg);
      color: var(--c-text);
      padding: 0.2rem 1rem;
      font-size: 1.25rem;
      color: var(--c-brand);
      border: 1px solid var(--c-brand);
      border-radius: 2rem;
    }
  }
  figure {
    margin-bottom: 3rem;
    height: auto;
    position: relative;

    img {
      aspect-ratio: 1;
      display: block;
      width: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    a {
      display: block;
      overflow: hidden;

      &:hover {
        img {
          transform: scale(1.03);
        }
      }
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    height: auto;

    h2 {
      font-size: 2em;
    }
    h2 a:hover {
      color: var(--c-brand);
    }
    p {
      font-size: 1.5em;
      margin: 1rem 0;
    }

    .blog__item__readmore {
      margin-top: auto;
      text-transform: uppercase;
      text-decoration: underline;
      font-size: 1.5em;

      &:hover {
        color: var(--c-brand);
      }
    }
  }
  @include viewport(from-tablet) {
    grid-row: span 2;
  }
  @include viewport(tablet) {
    grid-column: span 6;
  }
  @include viewport(phone) {
    grid-column: span 12;
    
    &__tags {
      li {
        font-size: 1.25em;
      }
    }
  }
}
</style> 